import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { BrowserRouter } from 'react-router';
import { Toaster } from 'sonner';
import { createQueryClient } from '@/lib/query-client';
import { ErrorBoundary } from '@/components/common/error-boundary';
import { ThemeProvider, useTheme } from '@/components/theme';
import { AuthProvider } from '@/features/auth/auth-context';
import { AppRoutes } from '@/routes/app-routes';

/** Sonner needs the resolved theme, which is only available inside the provider. */
function ThemedToaster() {
  const { resolvedTheme } = useTheme();

  return (
    <Toaster
      theme={resolvedTheme}
      position="top-right"
      richColors
      closeButton
      // Long enough to read a sentence, short enough not to obscure the UI.
      duration={5000}
    />
  );
}

export function App() {
  // Created once per mount rather than at module scope, so tests get a clean
  // cache per render instead of leaking state between cases.
  const [queryClient] = useState(createQueryClient);

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          {/* AuthProvider sits inside QueryClientProvider — it calls
              useQueryClient() to clear cached data on sign-out. */}
          <BrowserRouter>
            <AuthProvider>
              <AppRoutes />
              <ThemedToaster />
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
